// ? Material Ui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import React, { ReactElement } from 'react';

interface IProps {
  children: ReactElement;
}

const TrainingLayout: React.FC<IProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        py: 10,
      }}
    >
      <Container>
        <Grid container spacing={6}>
          {children}
        </Grid>
      </Container>
    </Box>
  );
};

export default TrainingLayout;
